import { render, staticRenderFns } from "./DataParser.vue?vue&type=template&id=aebdea4e&scoped=true&"
import script from "./DataParser.vue?vue&type=script&lang=js&"
export * from "./DataParser.vue?vue&type=script&lang=js&"
import style0 from "./DataParser.vue?vue&type=style&index=0&id=aebdea4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebdea4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aebdea4e')) {
      api.createRecord('aebdea4e', component.options)
    } else {
      api.reload('aebdea4e', component.options)
    }
    module.hot.accept("./DataParser.vue?vue&type=template&id=aebdea4e&scoped=true&", function () {
      api.rerender('aebdea4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/DataParser.vue"
export default component.exports